<template>
  <v-flex class="week-day-box ma-1 mb-2">
    <div v-if="!shift.approved" class="approval-needed-notice grey--text">
      Pending approval
    </div>
    <div :class="shift.approved ? 'approved' : 'pending-approval'">
      <router-link :to="{ name: 'shiftDetail', params: { shiftId: shift.id } }">
        <div v-if="shift.tradePending">
          <v-tooltip bottom v-if="!shift.tradeApprovalPending">
            <v-icon
              slot="activator"
              color="primary"
              > sync </v-icon>
              <span>Up for Trade</span>
          </v-tooltip>
          <v-tooltip bottom v-else>
            <v-icon
              slot="activator"
              color="warning"
              > sync </v-icon>
              <span>Trade accepted; pending manager approval</span>
          </v-tooltip>
        </div>
        <h4>
          {{ shift.location }}
        </h4>
      </router-link>
      <div>
        {{ shift.shiftRole }}
      </div>
      <div>
        {{ shift.startDatetime | moment("h:mma") }} -
        {{ shift.endDatetime | moment("h:mma") }}
      </div>
      <div>
        <v-tooltip bottom :disabled="!shift.hasDirections">
          <v-icon
            slot="activator"
            :color="shift.hasDirections ? 'blue' : 'grey lighten-2'"
            class="shift-details-icon"
            > location_on </v-icon>
            <span>Directions Available</span>
        </v-tooltip>

        <v-tooltip bottom :disabled="!shift.hasTravelBonus">
          <v-icon
            slot="activator"
            :color="shift.hasTravelBonus ? 'grey darken-2' : 'grey lighten-2'"
            class="shift-details-icon"
            > directions_car </v-icon>
            <span>{{ shift.travelBonusAmount }}</span>
        </v-tooltip>

        <v-tooltip bottom :disabled="!shift.hasCallInBonus">
          <v-icon
            slot="activator"
            :color="shift.hasCallInBonus ? 'grey darken-2' : 'grey lighten-2'"
            class="shift-details-icon"
            > phone </v-icon>
            <span>{{ shift.callInBonusAmount }}</span>
        </v-tooltip>

        <v-tooltip bottom :disabled="!shift.hasStraightBonus">
          <v-icon
            slot="activator"
            :color="shift.hasStraightBonus ? 'grey darken-2' : 'grey lighten-2'"
            class="shift-details-icon"
            > local_atm </v-icon>
            <span>{{ shift.straightBonusAmount }}</span>
        </v-tooltip>
      </div>
    </div>
  </v-flex>
</template>

<script>
export default {
  props: ['shift']
}
</script>

<style scoped>
  .shift-details-icon {
    cursor: default;
  }
  .pending-approval {
    opacity: 0.2;
    border: 1px dashed black;
    border-radius: 4px;
    padding: 4px;
  }
</style>

